import {QueryValue} from "./queryValue";

export class QueryCategory {
    type: string;
    isFilter: boolean;
    queryValues: QueryValue[];
    // ui only
    displayValue: string;

}